// extracted by mini-css-extract-plugin
export default {"order":"style_order__cCx8G","empty":"style_empty__OGni9"};